var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB2CloudAndSunDay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#B2_Cloud_and_sun_day_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76 32a2 2 0 01-2 2h-7a2 2 0 110-4h7a2 2 0 012 2zM63.44 42.61a2.001 2.001 0 00-2.83 2.83l5 4.94a2 2 0 002.82 0 2 2 0 000-2.82l-4.99-4.95zM62 22a2 2 0 001.42-.59l4.94-5a2 2 0 10-2.82-2.82l-5 4.94A2 2 0 0062 22zm-12 0a10 10 0 00-7.65 3.57 19.48 19.48 0 015.46 8.5 15.48 15.48 0 019.59 4.64A10 10 0 0050 22zm7.8 28.5A11.48 11.48 0 0146.4 62H12.1a11.499 11.499 0 11-.1-23h1.7a15.59 15.59 0 0130.9 0h1.7a11.5 11.5 0 0111.5 11.5zm-3.9 0a7.55 7.55 0 00-7.5-7.5h-5.6v-2a11.6 11.6 0 00-23.2 0v2l-5.6-.1a7.491 7.491 0 00-7.5 7.5A7.58 7.58 0 0012 58h34.4a7.491 7.491 0 007.5-7.5zM50 17a2 2 0 002-2V8a2 2 0 10-4 0v7a2 2 0 002 2zm-13.44 4.39a2 2 0 002.553.273 2 2 0 00.297-3.083l-5-4.94a2 2 0 10-2.82 2.82l4.97 4.93z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "B2_Cloud_and_sun_day_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h76v76H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/B2_Cloud_and_sun_day.cb41e430.svg";
export { SvgB2CloudAndSunDay as ReactComponent };